export default __webpack_public_path__ + "static/media/land.d2926cf9.png";